<template>
  <div class="monster-bonus text-center">
    <div class="row">
      <div class="col-12">
        <h1>{{formattedName}}</h1>
      </div>
<!--      <div class="col-12">-->
<!--        <img src="" class="img-fluid">-->
<!--      </div>-->

      <div class="col-12 mt-2 mb-2">
        <h4>Combat Stats</h4>
        <div class="row" v-if="monster">
          <EquipmentStat class="col" :icon="'attack'" :value="monster.attack_level"></EquipmentStat>
          <EquipmentStat class="col" :icon="'strength'" :value="monster.strength_level"></EquipmentStat>
          <EquipmentStat class="col" :icon="'defence'" :value="monster.defence_level"></EquipmentStat>
          <EquipmentStat class="col" :icon="'magic'" :value="monster.magic_level"></EquipmentStat>
          <EquipmentStat class="col" :icon="'ranged'" :value="monster.ranged_level"></EquipmentStat>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PlayerStat from "../PlayerStat";
  import EquipmentStat from "../stats/EquipmentStat";

  export default {
    name: "MonsterBonus",
    components: {EquipmentStat, PlayerStat},
    props: {
      monster: {
        type: Object,
        default() {
          return {
            name: 'No Monster Selected'
          }
        }
      },
    },
    computed: {
      formattedName: function () {
        if (this.monster)
          return this.ucHuman(this.monster.name);

        return '';
      }
    },
    methods: {
      //
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/MonsterBonus.vue